export default __webpack_public_path__ + "static/media/mirakl.54f2766e.svg";